class GraphQLService {
  buildServiceTree(schema) {
    return {
      queries: this._buildServiceTree(schema._queryType._fields, ''),
      mutations: {},
    };
  }

  _buildServiceTree(fields, fullParentPath) {
    const output = [];
    for (const fieldKey in fields) {
      if (fields.hasOwnProperty(fieldKey)) {
        const node = {};
        node.name = fields[fieldKey].type.name;
        node.path = fieldKey;
        node.fullPath =
          fullParentPath != '' ? `${fullParentPath}.${fieldKey}` : fieldKey;
        if (
          fields[fieldKey].hasOwnProperty('type') &&
          fields[fieldKey].type.hasOwnProperty('_fields')
        ) {
          node.fields = this._buildServiceTree(
            fields[fieldKey].type._fields,
            node.fullPath,
          );
        }
        output.push(node);
      }
    }
    return output;
  }

  escapeInputArg(arg) {
    // open object/array
    let outputStr = '';

    if (arg == null) {
      outputStr += 'null';
    } else if (arg instanceof Date) {
      outputStr += arg.getTime();
    } else if (Array.isArray(arg)) {
      outputStr += '[';
      arg.map((arrayItem, ii) => {
        outputStr += this.escapeInputArg(arrayItem);
        outputStr += ii != arg.length - 1 ? ',' : '';
      });
      outputStr += ']';
    } else if (typeof arg === 'object') {
      outputStr += '{';
      Object.keys(arg).map((property, ii) => {
        outputStr += ` ${property}: `;
        outputStr += this.escapeInputArg(arg[property]);
        outputStr += ii != Object.keys(arg).length - 1 ? ',' : '';
      });
      outputStr += '}';
    } else {
      outputStr += JSON.stringify(arg);
    }

    return outputStr;
  }

  buildQueryKeys(obj) {
    // console.log('obj', obj);
    let keys = '';
    // eslint-disable-next-line no-restricted-syntax
    for (const property in obj) {
      // eslint-disable-next-line no-prototype-builtins
      if (obj.hasOwnProperty(property)) {
        // TODO:  fix this - not all arrays should be treate
        if (obj[property] && Array.isArray(obj[property])) {
          keys += ` ${property}`;
        } else if (
          obj[property] &&
          typeof obj[property] === 'object' &&
          !(obj[property] instanceof Date)
        ) {
          let objKey = ` { ${this.buildQueryKeys(obj[property])} } `;
          objKey = objKey == ' {  } ' ? '' : objKey;
          keys += ` ${property}${objKey}`;
        } else {
          keys += ` ${property}`;
        }
      }
    }
    return keys;
  }

  // createGQLQuery(obj){
  //   return Object.keys(obj).map((k) => {
  //     let query = `${k}`;
  //     let element = obj[k];
  //     if (element) {
  //       if (element.aliasFor) {
  //         query = `${k}:${element.aliasFor}`;
  //       }
  //       if (element.fragment) {
  //         query = `fragment ${k} on ${element.fragment}`;
  //       }
  //       if (element.args) {
  //         let args = Object.keys(element.args).map((argKey) => {
  //           let argVar = "", processed = false;
  //
  //           if(element.processArgs)
  //           {
  //             if(element.processArgs[argKey]) {
  //               argVar = element.processArgs[argKey](element.args[argKey]);
  //               processed = true;
  //             }
  //           }
  //           if (!processed) {
  //             if (typeof element.args[argKey] === "object") {
  //               argVar = JSON.stringify(element.args[argKey]).replace(/\"([^(\")"]+)\":/g,"$1:");
  //             } else {
  //               argVar = `"${element.args[argKey]}"`;
  //             }
  //           }
  //           return `${argKey}:${argVar}`;
  //         }).join();
  //         query = `${query}(${args})`;
  //       }
  //       if (element.fields) {
  //         let fields = createGQLQuery(element.fields);
  //         query = `${query}{${fields}}`;
  //       }
  //     }
  //     return query;
  //   }).join();
  // }
}

export default GraphQLService;



// WEBPACK FOOTER //
// ./src/service/GraphQLService.js